<app-generic-label
  class="context-label"
  [class.context-label--more]="enableInfo && node && node.info"
  [label]="label">
  <!-- title -->
  <div
    class="context-label__header html"
    #title
    [innerHTML]="label.title | markdown"
    label-header></div>

  <!-- node actions -->
  <div *ngIf="node" class="context-label__actions" label-actions>
    <ng-content></ng-content>
    <app-node-actions
      *ngIf="enableActions"
      eventCategory="Context Node"
      [node]="node"
      theme="light">
    </app-node-actions>
  </div>

  <ng-container label-more>
    <!-- latin title -->
    <i *ngIf="node && node.info?.latinLabel" class="context-label__latin">
      {{ node.info.latinLabel }}
    </i>

    <!-- read more info -->
    <button
      @show
      *ngIf="enableInfo && node && node.info"
      type="button"
      app-button
      buttonTheme="light"
      buttonSize="xsmall"
      class="context-label__more"
      (click)="handleReadMoreClick()">
      Read More
    </button>
  </ng-container>
</app-generic-label>
